define('controllers/crm',['require','johngrid','nicEditlatest','date','daterangepicker'],function(require) {
    var CreateJohnGrid = require('johngrid');
    require('nicEditlatest');
    require('date');
    require('daterangepicker');

    return function () {
        var CRMDataSources = window.ServerData.feData.CRMDataSources;

		$(function () {
			/* Insert/Edit Form */
			var communicationTypesList = $("#CommunicationTypes"),
				keywordsList = $("#Keywords"),
				reasonsList = $("#Reasons"),
				actionsList = $("#Actions"),
				assignToList = $("#AssignTos"),
				selected = {
					ReasonIds: [],
					KeywordIds: [],
					ActionIds: []
				},
				reasonBoxesSelector = "input[name='ReasonIds']";
			var $canceluser = $('#canceluser');
			var $btnCancel = $('#btnCancel');
			var $lblCancel = $('#lblCancel');

			function setCancelText(isApproved) {
			    $btnCancel.text(isApproved ? 'Activated' : 'Inactivated');
			    isApproved ? $btnCancel.addClass('active') : $btnCancel.removeClass('active');
			}

			BindBoxes(communicationTypesList, CRMDataSources.CommunicationTypes, "CommunicationTypeId", "radio");
			BindBoxes(reasonsList, CRMDataSources.Reasons, "ReasonIds", "checkbox");
			BindBoxes(actionsList, CRMDataSources.Actions, "ActionIds", "checkbox");

			hookUpReasonsChangeEvent();
			function hookUpReasonsChangeEvent() {
				$(reasonBoxesSelector).off("change").on("change", function () {
					//toggle inside selected.ReasonIds
					var $this = $(this),
						reasonId = parseInt($this.val()),
						checked = $this.is(":checked");

					if (checked) {
						selected.ReasonIds.push(reasonId);
					} else {
						for (var i = selected.ReasonIds.length - 1; i >= 0; i--) {
							var srid = selected.ReasonIds[i];
							if (srid == reasonId) {
								selected.ReasonIds.splice(i, 1);
							}
						}
					}

					bindReasonsAndKeywords(true);
				});
			}
			function bindReasonsAndKeywords(clearKeywords) {
				//iterate over reason boxes, set "checked" attr accordingly
				$(reasonBoxesSelector).each(function () {
					var $this = $(this),
						reasonId = parseInt($this.val()),
						checked = $.inArray(reasonId, selected.ReasonIds) != -1;

					checked ? $this.prop("checked", true) : $this.prop("checked", false);
				});

				//bindboxes for keywords, based on selected.ReasonIds
				var keywords = [];
				for (var i = CRMDataSources.Reasons.length - 1; i >= 0; i--) {
					var reason = CRMDataSources.Reasons[i],
						checked = $.inArray(reason.id, selected.ReasonIds) != -1;

					if (checked) {
						for (var j = reason.keywordIds.length - 1; j >= 0; j--) {
							var keywordId = reason.keywordIds[j],
								alreadyIn = $.grep(keywords, function (k) { return k.id == keywordId }).length >= 1; //two reasons can have the same keyword

							if (!alreadyIn) {
								for (var k = CRMDataSources.Keywords.length - 1; k >= 0; k--) {
									var keyword = CRMDataSources.Keywords[k];

									if (keyword.id == keywordId) {
										keywords.push(keyword);
										break;
									}
								}
							}
						}
					}
				}
				BindBoxes(keywordsList, keywords, "KeywordIds", "checkbox");

				//iterate over keyword boxes, set "checked" attr accordingly
				if (clearKeywords != undefined) { selected.KeywordIds = []; }
				$("input[name='KeywordIds']").each(function () {
					var $this = $(this),
					keywordId = parseInt($this.val()),
					checked = $.inArray(keywordId, selected.KeywordIds) != -1;

					checked ? $this.prop("checked", true) : $this.prop("checked", false);
				});

				//bind Actions
				$("input[name='ActionIds']").each(function () {
					var $this = $(this),
					ActionId = parseInt($this.val()),
					checked = $.inArray(ActionId, selected.ActionIds) != -1;

					checked ? $this.prop("checked", true) : $this.prop("checked", false);
				});
			}


			function BindBoxes($element, ds, name, type) {
				var templates = [];
				for (var i = ds.length - 1; i >= 0; i--) {
					var item = ds[i],
						boxHtml = CreateBox(name, type, item);

					templates.push(boxHtml);
				}
				$element.html(templates.join(""));
			}
			function CreateBox(name, type, item, checked) {
				if (type == "checkbox" && (name=="ReasonIds" || name=="KeywordIds"))
				{
					var template = '<div style="width: 230px; position: relative; float: left;"><input type="{2}" name="{3}" id="{3}_{0}" value="{0}"{4} /><label for="{3}_{0}">{1}</label></div>',
						checkedAttr = checked == true ? " checked='checked'" : "";
				}
				else
				{
					var template = '<input type="{2}" name="{3}" id="{3}_{0}" value="{0}"{4} /><label for="{3}_{0}">{1}</label>',
						checkedAttr = checked == true ? " checked='checked'" : "";
				}

				return template.format(item.id, item.Name, type, name, checkedAttr);
			}

			$("#saveReasons, #saveKeywords").on("click", function () {
				var $this = $(this),
					method = $this.prop('id'),
					box = $this.prev(),
					newName = box.val(),
					data = { method: method, newName: newName },
					saveReasons = method == "saveReasons";

				$this.prop('disabled', true);

				if (!saveReasons) {
					data.reasonIds = selected.ReasonIds.join(",");
				}

				$.post(AJAX_Page, data, function (response) {
					Utilities.handleAJAXResponse(response, function (newOne) {
						if (saveReasons) {
							//update ui and underlying datasources
							var alreadyInDS = $.inArray(newOne.id, selected.ReasonIds) != -1;

							if (!alreadyInDS) {
								var boxHtml = CreateBox("ReasonIds", "checkbox", newOne, true);
								reasonsList.append(boxHtml);
								CRMDataSources.Reasons.push(newOne);
							}
							selected.ReasonIds.push(newOne.id);
							hookUpReasonsChangeEvent();
						} else {
							var alreadyInDS = $.inArray(newOne.id, selected.KeywordIds) != -1;

							if (!alreadyInDS) {
								var boxHtml = CreateBox("KeywordIds", "checkbox", newOne, true);
								keywordsList.append(boxHtml);
								CRMDataSources.Keywords.push(newOne);
							}

							//add keyword to all selected reasons, if not already there...
							for (var i = CRMDataSources.Reasons.length - 1; i >= 0; i--) {
								var reason = CRMDataSources.Reasons[i],
									checked = $.inArray(reason.id, selected.ReasonIds) != -1;


								if (checked) {
									var keywordOfReason = $.inArray(newOne.id, reason.keywordIds) != -1;
									if (!keywordOfReason) {
										reason.keywordIds.push(newOne.id);
									}
								}
							}
						}
						box.val("");
					}, function (error) {
						grid.utilities.setError(error);
					});
				}).complete(function () {
					$this.prop('disabled', false);
				});
			});

			$("input[name='Email']").on("change", function () {
				var $this = $(this),
					loading = $this.next(),
					emailSearchResult = loading.next();

				loading.show();
			    emailSearchResult.text('');
				$.post(AJAX_Page, { method: "searchForMember", Search: $this.val() }, function (response) {
					Utilities.handleAJAXResponse(response, function (member) {
						var found = member.CallerName != undefined;
						if (found) {
							//reset userid 
							searchUserId = member.UserId;
							console.log(searchUserId);
							//fill in boxes...
							$("input[name='Email']").val(member.Email);
							$("input[name='CallerName']").val(member.CallerName);
							$("input[name='Phone']").val(member.Phone);
							$("input[name='Company']").val(member.Company);

							if (member.IsMember) {
								$("input[name='IsMember']").prop("checked", true);
								emailSearchResult.text("Found a member...");
							} else {
								$("input[name='IsMember']").prop("checked", false);
								emailSearchResult.text("Found a user...");
							}
						} else {
							$("input[name='CallerName']").val("");
							$("input[name='Phone']").val("");
							$("input[name='Company']").val("");
							$("input[name='IsMember']").prop("checked", false);

							emailSearchResult.text("I didn't find a user...");
						}
					}, function (error) {
						grid.utilities.setError(error);
					});
				}).complete(function () {
					loading.hide();
				});
			});
			/******/

			/* Grid */
			var grid = CreateJohnGrid(),
				columns = [{ DataField: "CallerName" }, { DataField: "Email" }, { DataField: "Phone" }, { DataField: "Company" },
						   { DataField: "CreatedBy", HeaderText: "Creator" },
						   { DataField: "CreateDate" }, { DataField: "CompleteDate", HeaderText: "Completed" }],
				AJAX_Page = "CRMAJAX.aspx",
				editAndInsertTemplate = $("#createAndEditTemplate"),
				txtNotesHtmlID = "txtNotes",
				txtNotesHtml = new nicEditor({ fullPanel: true, maxHeight: 300 }).panelInstance(txtNotesHtmlID, { hasPanel: true });

			grid.insertHelpers.init(editAndInsertTemplate);
			grid.editHelpers.init(editAndInsertTemplate);
			grid.sorting.allowSorting = true;
			//grid.dsPostValues.sortClause = "CreateDate DESC";
			//grid.sorting.sortClientSide = true; //test all columns, thoroughly...keep in mind that you may want to switch back, if you end up doing the show more johngrid feature or simply limiting the results...


			var txtSearch = $("#txtSearch"),
				header = $("#header"),
				ddlComplete = $("#ddlComplete"),
				ddlAssignedToFilter = $("#ddlAssignedToFilter"),
				chkAssignedToAnytime = $("#chkAssignedToAnytime");

			$(".johnGridHeader", grid.$table).prepend(header);

			var communicationId = isNaN(requestQueryString("c")) || requestQueryString("c") == "" ? 0 : parseInt(requestQueryString("c")),
				userId = requestQueryString("u"),
				searchUserId = userId;

			if (communicationId > 0) {
				$("#ddlComplete option").first().prop("selected", true);
			}

			grid.onDataBinding = function () {
				grid.dsPostValues.communicationId = communicationId;
				grid.dsPostValues.userId = userId;

				grid.dsPostValues.CompletedStatus = ddlComplete.val();
				grid.dsPostValues.AssignedToFilter = ddlAssignedToFilter.val();
				grid.dsPostValues.AssignedAtAnyTime = chkAssignedToAnytime.is(":checked");

				grid.dsPostValues.search = txtSearch.val();
			};

            //set qs filter
			if (communicationId > 0) SetUpShowAllLink(communicationId);
			if (userId != "") SetUpShowAllLink(userId);
			function SetUpShowAllLink(Filter) {
				$("#communicationId").html("({0}) <a href='/callcenter/crm'>Show My Open Issues</a>".format(Filter));
			}

            //set default filter
		    var noQsFilter = userId === '' && communicationId === 0;
		    ddlComplete.val(noQsFilter ? 'Incompleted' : 'All'); //only show all by default if we have a user selected to filter on
		    ddlAssignedToFilter.val(noQsFilter ? ServerData.user.id : '');

			grid.insertHelpers.onAdd = function () {
				//set default values
				$("input", communicationTypesList).first().prop("checked", true);
				$("input[name='CreateDate']", editAndInsertTemplate).val(new Date().toString("dddd, MMMM d, yyyy h:mmtt"));
				selected.ReasonIds = [];
				selected.KeywordIds = [];
				selected.ActionIds = [];
				bindReasonsAndKeywords();
				txtNotesHtml.instanceById(txtNotesHtmlID).setContent("");
				SetUpNotesGrid([]);
				ResetAssignHistory();
				$("span[data-name='CompleteDate']").text("");
				$("#spnWillBeNotifiedMsg").hide();

				if (userId != "") $("input[name='Email']").val(userId).trigger("change");

				$("#existingCommunication").hide();
			};

			grid.editHelpers.onEdit = function (item) {
			    setCancelText(item.IsApproved);

				$("input[name='CommunicationTypeId'][value='" + item.CommunicationTypeId + "']").prop("checked", true);
				if (item.IsMember) { $("input[name='IsMember']").prop("checked", true); }
				selected.ReasonIds = item.ReasonIds;
				selected.KeywordIds = item.KeywordIds;
				selected.ActionIds = item.ActionIds;

				var CompleteDate = $("input[name='Completed']");
				if (item.CompleteDate != "") {
					CompleteDate.prop("checked", true);
				} else {
					CompleteDate.prop("checked", false);
				}
				bindReasonsAndKeywords();
				txtNotesHtml.instanceById(txtNotesHtmlID).setContent("");
				SetUpNotesGrid(item.Notes);

				ResetAssignHistory();
				$("#ddlAssignToUserId").val(item.CurrentlyAssignedUserId);
				$("#spnWillBeNotifiedMsg").hide();

				$("#existingCommunication").show();

				var existingCommunicationForActivated = $("#existingCommunicationForActivated");
				item.UserId != null ? existingCommunicationForActivated.show() : existingCommunicationForActivated.hide();
			};

			grid.utilities.validateItem = function (item) {
				var errors = [];
				item.Notes = Utilities.htmlEncode(txtNotesHtml.instanceById(txtNotesHtmlID).getContent());
				item.AssignToUserId = $("#ddlAssignToUserId").val();
				console.log(searchUserId);
				item.userId = searchUserId;
				return errors;
			};

			grid.init($("#tblCommunications"), columns, AJAX_Page);
		    grid.loadItem(communicationId);
			$(".johnGridHeader", grid.$table).prepend(header);
			grid.databind();

			$("#ddlAssignToUserId").on("change", function () {
				var personSelected = $(this).val() != "",
					spnWillBeNotifiedMsg = $("#spnWillBeNotifiedMsg");

				personSelected ? spnWillBeNotifiedMsg.show() : spnWillBeNotifiedMsg.hide();
			});

			/*Assign History*/
			var loadedAssignHistory = false,
				tblAssignHistory = $("#tblAssignHistory"),
				assignHistory = $("#assignHistory"),
				assignHistoryGrid = CreateJohnGrid(),
				columns = [{ DataField: "EMail" }, { DataField: "NameFirst" }, { DataField: "NameLast" }, { DataField: "Comment" }, { DataField: "CreateDate" }];

			assignHistoryGrid.init(tblAssignHistory, columns);

			function ResetAssignHistory() {
				loadedAssignHistory = false;
				tblAssignHistory.hide();
				assignHistory.text("Show Assign History");
				$("#ddlAssignToUserId option").first().prop("selected", true);
			}

			assignHistory.on("click", function (e) {
				e.preventDefault();

				var showing = tblAssignHistory.css("display") != "none",
					$this = $(this);

				if (!showing) {
					if (loadedAssignHistory) {
						//show grid
						tblAssignHistory.show();
						$this.text("Hide Assign History");
					} else {
						//go get data 
						var loading = $(grid.htmlHelpers.loadingImg(true)),
							errorDiv = $("#assignHistoryError");

						loading.insertAfter($this);
						$this.hide();

						$.post(AJAX_Page, { method: "getAssignHistory", PrimaryKey: $("input[name='PrimaryKey']").val() }, function (response) {
							Utilities.handleAJAXResponse(response, function (assignHistory) {


								assignHistoryGrid.databind(assignHistory);

								loadedAssignHistory = true;
								$this.show().text("Hide Assign History");
								tblAssignHistory.show();
								errorDiv.hide();
							},
							function (error) {
								errorDiv.show().html(error);
								$this.show().text("Try Again");
							});
						}).complete(function () {
							loading.remove();
						});
					}
				} else {
					tblAssignHistory.hide();
					$this.text("Show Assign History");
				}
			});

			var NotesGrid = null,
				ShowingPastNotes = false;

			function SetUpNotesGrid(notes) {
				if (NotesGrid == null) {
					NotesGrid = CreateJohnGrid();
					NotesGrid.init($("#tblPastNotes"));
				}

				SetNotesExpandable(notes);
				NotesGrid.databind(notes);
				SetNotesExpandableHandler(notes.length);
			}

			function SetNotesExpandable(notes) {
				var expandableTemplate = "<a href='#' class='PastNoteToggle'>Toggle</a>" +
										 "<div class='PastNote'>{0}</div>";

				for (var i = 0; i < notes.length; i++) {
					notes[i].Note = expandableTemplate.format(notes[i].Note);
				}
			}
			function SetNotesExpandableHandler(noteCount) {
				var ToggleAllPastNotes = $("#ToggleAllPastNotes");

				if (noteCount > 0) {
					var pastNotes = $("div.PastNote", NotesGrid.$table);

					ShowingPastNotes = false;
					ToggleAllPastNotes.show().text("(show all)").off("click").on("click", function (e) {
						e.preventDefault();

						if (ShowingPastNotes) {
							pastNotes.hide();
							ToggleAllPastNotes.text("(show all)");
							ShowingPastNotes = false;
						} else {
							pastNotes.show();
							ToggleAllPastNotes.text("(hide all)");
							ShowingPastNotes = true;
						}
					});

					$("a.PastNoteToggle", NotesGrid.$table).off("click").on("click", function (e) {
						e.preventDefault();
						$(this).next().toggle();
					});

					//also make note itself clickable. But still allow anchors to be clicked, by stoping propogation on any anchor clicks within a note
					//NOTE that if double click to select, it closes....
					//pastNotes.off("click").on("click", function (e) {
					//    //var isTextSelected = (window.getSelection != undefined &&
					//    $(this).toggle();
					//});
					//$("a", pastNotes).off("click").on("click", function (e) {
					//    e.stopPropagation();
					//});
				} else {
					ToggleAllPastNotes.hide();
				}
			}

			/******/

			/*Ability To Copy Link to Communication*/
			$("#aCopyLink").on("click", function (e) {
				e.preventDefault();
				var cId = $("input[name='PrimaryKey']", editAndInsertTemplate).val(),
					template = "{0}//{1}/CallCenter/CRM/?c={2}";

				copyToClipboard(template.format(window.location.protocol, window.location.host, cId));
			});
			function copyToClipboard(text) {
				window.prompt("Copy to clipboard: Ctrl+C, Enter", text);
			}
			/*****/

			var adestForm = document.forms['form1'];
			if (!adestForm) {
				adestForm = document.form1;
			}
			function submitForm(eventTarget, eventArgument) {
				if (!adestForm.onsubmit || (adestForm.onsubmit() != false)) {
					adestForm.adest_EventTarget.value = eventTarget;
					adestForm.submit();
				}
			}


			$("#btnOperateAsUser").on("click", function (e) {
				e.preventDefault();
				txtNotesHtml.instanceById(txtNotesHtmlID).setContent("");
				submitForm('btnOperateAsUser', '');
			});

			$("input[name='CC_List']").autocomplete({ source: CRMDataSources.AssignToUsers });

		    //cancel member
			var isAdmin = $.inArray('Admin', window.ServerData.user.roles) > -1;
			//isAdmin ? $canceluser.show() : $canceluser.hide();
			$canceluser.show();
            if (isAdmin) {
                $btnCancel.on('click', function () {
                    var $this = $(this);
                    var com = grid.utilities.selectedItem;
                    if (!com.IsApproved || confirm('This will make the user unable to log in. You sure?')) {
                        $this.prop('disabled', true);
                        setCancelText(!com.IsApproved);
                        $.post('/api/users/setapproved', { UserId: com.UserId, IsApproved: !com.IsApproved }).then(function () {
                            com.IsApproved = !com.IsApproved;
                            $this.prop('disabled', false);
                        }, function (xhr) {
                            setCancelText(com.IsApproved);
                            $this.prop('disabled', false);
                            alert(JSON.parse(xhr.responseText).Message);
                        });
                    }
                });
			}

		    Utilities.generalDateRangePicker('#txtDateRange', function setTimeFilter(start, end) {
		        grid.dsPostValues.timeFilter = Utilities.getTimeFilter(start, end);
		    }, {opens: 'right'});

			Utilities.setDefaultButton(header, $(".btnRefresh", header.parent()));
			txtSearch.focus();
			/******/
		});
	};
});
